<template>
  <AuthWrapper>
    <router-view />
  </AuthWrapper>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, watch } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { useKeycloak } from "@/composables/useKeycloak";
import AuthWrapper from "@/components/AuthWrapper.vue";

const { keycloak, token } = useKeycloak();
const authStore = useAuthStore();

// Watch for changes in the token and update the store
watch(token, (newToken) => {
  if (newToken) {
    authStore.setToken(newToken);

    const tokenParsed = keycloak.value?.tokenParsed;
    if (tokenParsed) {
      authStore.setUser({
        id: tokenParsed.sub,
        username: tokenParsed.preferred_username,
        email: tokenParsed.email,
        roles: tokenParsed.realm_access?.roles || [],
      });
    }
  }
});

const handleInteraction = () => {
  authStore.checkSession();
};

// Optionally, initialize the store on mount if already authenticated
onMounted(async () => {
  if (keycloak.value?.authenticated) {
    const tokenParsed = keycloak.value.tokenParsed;
    if (tokenParsed) {
      await authStore.initialize();
      authStore.setUser({
        id: tokenParsed.sub,
        username: tokenParsed.preferred_username,
        email: tokenParsed.email,
        roles: tokenParsed.realm_access?.roles || [],
      });
      authStore.setToken(keycloak.value.token);
    }
  }

  window.addEventListener("click", handleInteraction);
  window.addEventListener("keydown", handleInteraction);
});

onUnmounted(() => {
  window.removeEventListener("click", handleInteraction);
  window.removeEventListener("keydown", handleInteraction);
});
</script>
